'use client'

import { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

const ModalComponent = ({
  isOpen,
  onClose,
  title,
  children,
  initialData = {},
  onSave = () => {},
  customFooter = null,
  hideDefaultFooter = false
}) => {
  if (!isOpen) return null

  const [formData, setFormData] = useState(initialData)

  useEffect(() => {
    if (isOpen) {
      setFormData(initialData || {})
    }
  }, [initialData, isOpen])

  const handleChange = useCallback(event => {
    const { name, type, checked, value, files } = event.target
    const parsedValue = type === 'checkbox'
      ? checked
      : type === 'radio'
        ? checked ? value : undefined
        : type === 'file'
          ? files
          : type === 'number'
            ? value === '' ? '' : parseFloat(value)
            : value

    setFormData(prev => ({
      ...prev,
      [name]: parsedValue
    }))
  }, [])

  const handleSubmit = e => {
    e.preventDefault()
    onSave(formData)
  }

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-center z-50'>
      <div className='bg-white rounded-lg max-w-4xl max-h-screen overflow-y-auto shadow-lg p-6'>
        <div className='border-b border-gray-300 pb-3'>
          <h3 className='text-lg font-semibold text-greenPrimary'>{title}</h3>
        </div>

        <form className='mt-4' onSubmit={handleSubmit} autoComplete='off'>
          {typeof children === 'function'
            ? children({ formData, handleChange })
            : children ?? null}

          {!hideDefaultFooter && (
            customFooter
              ? (
                <div className='flex justify-end space-x-4 mt-4'>
                  {typeof customFooter === 'function'
                    ? customFooter({ formData, handleChange })
                    : customFooter}
                </div>
                )
              : (
                <div className='flex justify-end space-x-4 mt-4'>
                  <button
                    type='button'
                    onClick={onClose}
                    className='px-4 py-2 rounded bg-gray-100 text-greenPrimary hover:bg-gray-200'
                  >
                    Cancel
                  </button>
                  <button
                    type='submit'
                    className='px-4 py-2 rounded bg-greenPrimary text-white hover:opacity-90'
                  >
                    Save
                  </button>
                </div>
                )
          )}
        </form>
      </div>
    </div>
  )
}

ModalComponent.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  initialData: PropTypes.object,
  onSave: PropTypes.func,
  customFooter: PropTypes.node,
  hideDefaultFooter: PropTypes.bool
}

export default ModalComponent
